import Vue from 'vue';

export default {
    state:{
      tareas:{
       
      }
    },
    mutations: {
      
    },
    actions: { 
      
    },
    getters: {  
      
    },
    
}


// WEBPACK FOOTER //
// ./src/modules/tareas.js